// extracted by mini-css-extract-plugin
export var boxItems = "_1o-1";
export var button = "_1o-5";
export var filterGroupBox = "_1o-0";
export var icon = "_1o-2";
export var iconSecondary = "_1o-4";
export var iconWrapper = "_1o-3";